import React from 'react';
import { Line } from 'react-chartjs-2';
import { IoArrowDownSharp, IoArrowUpSharp } from 'react-icons/io5';
import { FormattedMessage } from 'react-intl';
import { Col, Row } from 'reactstrap';

interface AssistanceDashboardUtilitiesProps {
    kpiData: any;
}

const AssistanceDashboardUtilities: React.FC<AssistanceDashboardUtilitiesProps> = ({ kpiData }) => {
    const renderKpiBox = (title: string, currentValue: number | null, pastValue: number | null, comparisonData: any) => {
        return (
            <Col xl={12} lg={12} md={12} sm={12} xs={12} className="mb-3">
                <div
                    style={{
                        backgroundColor: "#6A1B9A",
                        color: "#ffffff",
                        padding: "1rem",
                        paddingLeft: "1rem",
                        borderRadius: "8px",
                        textAlign: "center",
                        height: "100%",
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gridTemplateRows: "auto auto auto",
                        gap: "0.3rem"
                    }}
                >
                    {/* Título e Valor (1) */}
                    <div style={{ fontSize: "0.9rem", textAlign: "left" }}>
                        <FormattedMessage id="Screens.Dashboard.Assistances.Number.Current.Week" />
                        {" "}
                        <strong>{comparisonData?.currentWeekAssistances ?? "N/A"}</strong>
                    </div>

                    {/* Comparação com Semana Anterior (2) */}
                    <div style={{ fontSize: "0.9rem", textAlign: "left" }}>
                        <FormattedMessage id="Screens.Dashboard.Assistances.Number.Past.Week" />
                        {" "}
                        <strong>{comparisonData?.pastWeekAssistances ?? "N/A"}</strong>
                    </div>

                    {/* Setas e Percentagem (3) */}
                    <div style={{ gridColumn: "1 / 3", textAlign: "left" }}>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "left" }}>
                            {comparisonData?.currentWeekAssistances &&
                                comparisonData?.pastWeekAssistances &&
                                comparisonData.currentWeekAssistances >
                                comparisonData.pastWeekAssistances ? (
                                <IoArrowUpSharp size={20} />
                            ) : (
                                <IoArrowDownSharp size={20} />
                            )}
                            <span style={{ marginLeft: "0.5rem" }}>
                                {comparisonData?.currentWeekAssistances &&
                                    comparisonData?.pastWeekAssistances
                                    ? (
                                        ((comparisonData.currentWeekAssistances -
                                            comparisonData.pastWeekAssistances) /
                                            comparisonData.pastWeekAssistances) *
                                        100
                                    ).toFixed(2) + "%"
                                    : "0%"}
                            </span>
                        </div>
                    </div>

                    {/* Gráfico de Linha (4) */}
                    <div style={{ gridColumn: "1 / 3", height: "100px" }}>
                        <Line
                            data={{
                                labels: ['', '', '', '', '', ''],
                                datasets: [
                                    {
                                        label: '',
                                        data: [
                                            comparisonData?.assistancesSixMonthsAgo ?? 0,
                                            comparisonData?.assistancesFiveMonthsAgo ?? 0,
                                            comparisonData?.assistancesFourMonthsAgo ?? 0,
                                            comparisonData?.assistancesThreeMonthsAgo ?? 0,
                                            comparisonData?.assistancesTwoMonthsAgo ?? 0,
                                            comparisonData?.assistancesOneMonthAgo ?? 0,
                                        ],
                                        fill: false,
                                        borderColor: '#ffffff',
                                        tension: 0.1,
                                    },
                                ],
                            }}
                            options={{
                                responsive: true,
                                maintainAspectRatio: false,
                                plugins: {
                                    legend: { display: false },
                                    title: { display: false },
                                },
                                scales: {
                                    x: {
                                        ticks: { color: '#ffffff' },
                                        grid: { display: false },
                                    },
                                    y: {
                                        ticks: { color: '#ffffff' },
                                        grid: { display: false },
                                    },
                                },
                            }}
                        />
                    </div>

                    {/* Média e Variação (5) */}
                    <div style={{ gridColumn: "1 / 3", textAlign: "left" }}>
                        Média 6 meses:{" "}
                        {([
                            comparisonData?.assistancesSixMonthsAgo ?? 0,
                            comparisonData?.assistancesFiveMonthsAgo ?? 0,
                            comparisonData?.assistancesFourMonthsAgo ?? 0,
                            comparisonData?.assistancesThreeMonthsAgo ?? 0,
                            comparisonData?.assistancesTwoMonthsAgo ?? 0,
                            comparisonData?.assistancesOneMonthAgo ?? 0,
                        ]
                            .reduce((acc, curr) => acc + curr, 0) / 6
                        ).toFixed(1)}
                        <strong>
                            (
                            {(
                                comparisonData?.assistancesSixMonthsAgo &&
                                    comparisonData?.assistancesSixMonthsAgo !== 0
                                    ? (
                                        ((comparisonData.assistancesOneMonthAgo ?? 0) -
                                            (comparisonData.assistancesSixMonthsAgo ?? 0)) /
                                        comparisonData.assistancesSixMonthsAgo
                                    ) * 100
                                    : 0
                            ).toFixed(1)}%
                            )
                        </strong>
                    </div>
                </div>
            </Col>
        );
    };

    return (
        <div>
            <Row style={{ flexWrap: "wrap" }}>
                {kpiData && kpiData.assistancesComparison && renderKpiBox(
                    "Assistências da Semana",
                    kpiData.assistancesComparison.currentWeekAssistances,
                    kpiData.assistancesComparison.pastWeekAssistances,
                    kpiData.assistancesComparison
                )}

            </Row>
        </div>
    );
};

export default AssistanceDashboardUtilities;
